import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { findUsersInProject } from '../../api/projects';
import { User } from '../UserProfile/userProfileSlice';

export const getProjectUsersAsync = createAsyncThunk(
  'projectUsers/findUsersInProject',
  findUsersInProject
);

interface ProjectUsersState {
  data: User[];
  loading: boolean;
  error: string | null;
}

const initialState: ProjectUsersState = {
  data: [],
  loading: false,
  error: null
};

const projectUsersSlice = createSlice({
  name: 'projectUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectUsersAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProjectUsersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.users;
      })
      .addCase(getProjectUsersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch project users';
      });
  }
});

export default projectUsersSlice;